module.exports = __webpack_public_path__ + "img/pedido-medico.16be3ef3.png";